var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "template1" },
    [
      _c(
        "el-form",
        {
          ref: "childForm",
          staticClass: "demo-ruleForm",
          attrs: { model: _vm.quality, "label-width": "100px" },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "分区：", prop: "region_name" } },
            [
              _c("el-input", {
                attrs: {
                  type: "text",
                  placeholder: "请输入分区",
                  maxlength: "6",
                  "show-word-limit": "",
                },
                model: {
                  value: _vm.quality.region_name,
                  callback: function ($$v) {
                    _vm.$set(_vm.quality, "region_name", $$v)
                  },
                  expression: "quality.region_name",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "分区类型：", prop: "product_source" } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    filterable: "",
                    placeholder: "请选择分区类型",
                    disabled: _vm.quality.id ? true : false,
                  },
                  on: { change: _vm.product_change },
                  model: {
                    value: _vm.quality.product_source,
                    callback: function ($$v) {
                      _vm.$set(_vm.quality, "product_source", $$v)
                    },
                    expression: "quality.product_source",
                  },
                },
                _vm._l(_vm.options, function (item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.name, value: item.id },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _vm.quality.product_source == 2
            ? _c(
                "el-form-item",
                { attrs: { label: "选择标签：", prop: "product_source_id" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { filterable: "", placeholder: "选择标签" },
                      model: {
                        value: _vm.quality.product_source_id,
                        callback: function ($$v) {
                          _vm.$set(_vm.quality, "product_source_id", $$v)
                        },
                        expression: "quality.product_source_id",
                      },
                    },
                    _vm._l(_vm.options1, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.name, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.quality.product_source == 2 ||
          _vm.quality.product_source == 3 ||
          _vm.quality.product_source == 4 ||
          _vm.quality.product_source == 6
            ? _c(
                "el-form-item",
                {
                  attrs: {
                    label: "选择分类：",
                    prop: "product_source_category_name",
                  },
                },
                [
                  _c("el-input", {
                    attrs: {
                      type: "text",
                      disabled: true,
                      placeholder: "请选择分类：",
                    },
                    model: {
                      value: _vm.quality.product_source_category_name,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.quality,
                          "product_source_category_name",
                          $$v
                        )
                      },
                      expression: "quality.product_source_category_name",
                    },
                  }),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.category_name_click },
                    },
                    [_vm._v("选择")]
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-form-item",
            { attrs: { label: "分区标题背景图：", prop: "head_url" } },
            [
              _c("b-file-upload", {
                key: "head_url",
                attrs: { accepts: ["jpg", "jpeg", "png"], limit: 1 },
                model: {
                  value: _vm.head_url_List,
                  callback: function ($$v) {
                    _vm.head_url_List = $$v
                  },
                  expression: "head_url_List",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "分区标题按钮背景图：", prop: "main_url" } },
            [
              _c("b-file-upload", {
                key: "main_url",
                attrs: { accepts: ["jpg", "jpeg", "png"], limit: 1 },
                model: {
                  value: _vm.main_url_List,
                  callback: function ($$v) {
                    _vm.main_url_List = $$v
                  },
                  expression: "main_url_List",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "按钮文字颜色：", prop: "main_url" } },
            [
              _c("el-color-picker", {
                model: {
                  value: _vm.quality.btn_color,
                  callback: function ($$v) {
                    _vm.$set(_vm.quality, "btn_color", $$v)
                  },
                  expression: "quality.btn_color",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "分区标题跳转按钮图：", prop: "more_url" } },
            [
              _c("b-file-upload", {
                key: "more_url",
                attrs: { accepts: ["jpg", "jpeg", "png"], limit: 1 },
                model: {
                  value: _vm.more_url_List,
                  callback: function ($$v) {
                    _vm.more_url_List = $$v
                  },
                  expression: "more_url_List",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: { label: "分区详情页面轮播图图片：", prop: "banner_url" },
            },
            [
              _c("b-file-upload", {
                key: "banner_url",
                attrs: { accepts: ["jpg", "jpeg", "png"], limit: 1 },
                model: {
                  value: _vm.banner_url_List,
                  callback: function ($$v) {
                    _vm.banner_url_List = $$v
                  },
                  expression: "banner_url_List",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "提示",
            visible: _vm.centerDialogVisible,
            width: "60%",
            center: "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.centerDialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticStyle: { height: "400px", "overflow-y": "auto" } },
            [
              _c("el-tree", {
                ref: "trees",
                attrs: {
                  data: _vm.treedata,
                  "show-checkbox": "",
                  "node-key": "id",
                  "default-checked-keys": _vm.checkedkeys,
                  props: _vm.defaultProps,
                },
                on: { "check-change": _vm.checkchange },
              }),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.centerDialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.qd } },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }